/** Must match FbrSmartApp.Api.Middleware.HttpHeaderNames.ActiveAppId */
export const HttpHeaderNames = {
    ActiveAppId: 'X-Active-App-Id',
} as const;
